import styled from "styled-components";

export default styled.header`
  height: ${props => props.autoHeight || "72px"};
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
`;
